import axios from "axios";
import { baseUrl } from "../../../../../apis/util";

/**
 * Impact category keys — must match HeaderBox RightBox IMPACT_CATEGORIES / EN 15804 indicators.
 * Flow 31 total = sum of rows across 31.1a, 31.1b, 31.2a, 31.2b, 31.3, 31.4, 31.5.
 */
const IMPACT_KEYS = [
  "global_warming",
  "ozone_depletion",
  "smog",
  "acidification",
  "eutrophication_terrestrial",
  "eutrophication_freshwater",
  "eutrophication_marine",
  "carcinogenics",
  "non_carcinogenics",
  "respiratory_effects",
  "ecotoxicity",
  "fossil_fuel_depletion",
  "land_use",
  "water_use",
  "resource_use_minerals_metals",
  "ionising_radiation",
];

function impactValueFromRow(row, key) {
  const raw =
    row[key] ??
    row[`impact_${key}`] ??
    row.impact_categories?.[key];
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

function sumImpactTotalsFromRows(rows) {
  const totals = {};
  IMPACT_KEYS.forEach((k) => {
    totals[k] = 0;
  });
  (rows || []).forEach((row) => {
    IMPACT_KEYS.forEach((k) => {
      totals[k] += impactValueFromRow(row, k);
    });
  });
  return totals;
}

function authHeaders() {
  return {
    Authorization: "Bearer " + localStorage.getItem("access_token"),
    "Content-Type": "application/json",
  };
}

async function getDataArray(url) {
  try {
    const response = await axios({
      method: "get",
      url,
      headers: authHeaders(),
    });
    const data = response.data?.data;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

/**
 * Fetches LCA row data for all Raw Materials sub-flows under 31 and returns summed impact_totals.
 */
export async function fetchFlow31AggregatedImpactTotals(productId) {
  if (!productId) {
    return null;
  }

  const base = `${baseUrl}/api/business/product/${productId}`;

  const [
    flow31_1a,
    flow31_1b,
    flow31_2a,
    flow31_2b,
    flow31_3,
    flow31_4,
    flow31_5,
  ] = await Promise.all([
    getDataArray(`${base}/component-lca`),
    getDataArray(`${base}/product-specific-packaging`),
    getDataArray(`${base}/transport-packaging-lca`),
    getDataArray(`${base}/transport-packaging-outgoing-lca`),
    getDataArray(`${base}/water-usage-lca`),
    getDataArray(`${base}/surplus-transport-lca`),
    getDataArray(`${base}/losses-lca`),
  ]);

  const allRows = [
    ...flow31_1a,
    ...flow31_1b,
    ...flow31_2a,
    ...flow31_2b,
    ...flow31_3,
    ...flow31_4,
    ...flow31_5,
  ];

  return sumImpactTotalsFromRows(allRows);
}
